import { render, staticRenderFns } from "./_form_popup.vue?vue&type=template&id=51f81ca9&scoped=true"
import script from "./_form_popup.vue?vue&type=script&lang=js"
export * from "./_form_popup.vue?vue&type=script&lang=js"
import style0 from "./_form_popup.vue?vue&type=style&index=0&id=51f81ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f81ca9",
  null
  
)

export default component.exports